import {
  btyHolderNum
} from '../../config/apiServe/new-rpc'
export default {
  data() {
    return {
      baseCoin: require(`../../assets/img/coin${process.env.VUE_APP_BASECOIN_URL}`),
      symbol: process.env.VUE_APP_BASECOIN,
      holders: 0
    };
  },
  mounted() {
    this.getCoinsHolders()
  },
  methods: {
    getCoinsHolders() {
      btyHolderNum().then(res => {
        if (res.error === null) this.holders = res.result
      })
    }
  }
};